export default "__VITE_ASSET__7ac0cc5a__"